import { useApiQuery } from '@/api/hooks/useQuery';
import { campaignKeys } from '@/api/queryKeys';

/**
 * Fetches a campaign's UGC guidance (content requirements): ENCOURAGE (do's) and
 * AVOID (don'ts) items, plus example imagery on ENCOURAGE items.
 */
export function useCampaignGuidance(id: number, enabled = true) {
  return useApiQuery({
    queryKey: campaignKeys.guidance(id),
    queryFn: (api) => async () => {
      const response = await api.campaigns.campaignsControllerGetCampaignGuidance(id);
      return response.data;
    },
    enabled: enabled && !!id && id > 0,
  });
}
